import React from 'react'
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import AboutUs from './components/AboutUs/AboutUs'
import { Auth } from './components/Auth/Auth'
import { BlogDetails } from './components/Blogs/BlogDetails'
import { Blogs } from './components/Blogs/Blogs'
import OrderFor from './components/CatalogueN/OrderForm'
import Products from './components/CatalogueN/Products'
import Contact from './components/ContactUs/Contact'
import DiwaliPacks from './components/DiwaliPacks/DiwaliPacks'
import LightupPack from './components/DiwaliPacks/LightupPack'
import MoodPack from './components/DiwaliPacks/MoodPack'
import TreatPack from './components/DiwaliPacks/TreatPack'
import TwistPack from './components/DiwaliPacks/TwistPack'
import FAQ from './components/FAQ/FAQ'
import Footer from './components/footer/footer'
import Homepage from './components/Homepage'
import AllCompanies from './components/Homepage/Brands/AllCompanies'
import OurClients from './components/Homepage/Brands/OurClients'
import Navbar from './components/Navbar/Navbar'
import Redirect from './components/Redirect'
import ScrollToTop from './components/ScrollToTop'
import Seller from './components/Seller/Seller'
import { PrivacyPolicy } from './components/TermsAndCondition/PrivacyPolicy'
import { TermsOfService } from './components/TermsAndCondition/TermsOfService'
import { AuthProvider } from './providers/AuthProvider'
import { Carts } from './components/Carts/Carts'
import { CartDetails } from './components/Carts/CartDetails'

function App() {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  return (
    <>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='light'
      />
      <div className='page'>
        <AuthProvider>
          <Router>
            <ScrollToTop>
              <Routes>
                <Route path='/auth' element={<Auth />} />
                <Route
                  path='/'
                  exact
                  element={
                    <>
                      <Navbar /> <Homepage /> <Footer />{' '}
                    </>
                  }
                />
                <Route
                  path='/collections/men/products/mens-5-year-essential-tee'
                  exact
                  element={
                    <Redirect url='https://store.hustlemad.com/products/mens-5-year-essential-tee' />
                  }
                />
                <Route
                  path='/collections/men/products/hoodie'
                  exact
                  element={
                    <Redirect url='https://store.hustlemad.com/collections/men/products/hoodie' />
                  }
                />
                <Route
                  path='/about'
                  exact
                  element={<Navigate to='/ourstory' replace />}
                />
                <Route
                  path='/ourstory'
                  exact
                  element={
                    <>
                      <Navbar />
                      <AboutUs /> <Footer />{' '}
                    </>
                  }
                />
                <Route
                  path='/contact'
                  exact
                  element={
                    <>
                      <Navbar />
                      <Contact /> <Footer />{' '}
                    </>
                  }
                />
                <Route
                  path='/faq'
                  exact
                  element={
                    <>
                      <Navbar />
                      <FAQ /> <Footer />{' '}
                    </>
                  }
                />
                <Route
                  path='/catalogue'
                  exact
                  element={
                    <>
                      <Navbar />
                      <Products />
                    </>
                  }
                />
                <Route
                  path='/catalogue/:cartId/add'
                  exact
                  element={
                    <>
                      <Navbar />
                      <Products />
                    </>
                  }
                />
                <Route
                  path='/order'
                  exact
                  element={
                    <>
                      <Navbar />
                      <OrderFor />
                    </>
                  }
                />

                <Route path='/carts'
                  exact
                  element={
                    <>
                      <Navbar />
                      <Carts />
                      <Footer />
                    </>
                  }
                />
                <Route path='/carts/:id'
                  exact
                  element={
                    <>
                      <Navbar />
                      <CartDetails />
                      <Footer />
                    </>
                  }
                />
                <Route
                  path='/partner'
                  exact
                  element={
                    <>
                      <Navbar />
                      <Seller /> <Footer />
                    </>
                  }
                />
                <Route
                  path='/clients'
                  exact
                  element={
                    <>
                      <Navbar />
                      <OurClients /> <Footer />
                    </>
                  }
                />
                <Route
                  path='/allcompanies'
                  exact
                  element={
                    <>
                      <Navbar />
                      <AllCompanies /> <Footer />
                    </>
                  }
                />
                <Route
                  path='/diwalipacks'
                  exact
                  element={
                    <>
                      <Navbar />
                      <DiwaliPacks />
                    </>
                  }
                />
                <Route
                  path='/diwalipacks/moodpack'
                  exact
                  element={
                    <>
                      <Navbar />
                      <MoodPack />
                    </>
                  }
                />
                <Route
                  path='/diwalipacks/treatpack'
                  exact
                  element={
                    <>
                      <Navbar />
                      <TreatPack />
                    </>
                  }
                />
                <Route
                  path='/diwalipacks/twistpack'
                  exact
                  element={
                    <>
                      <Navbar />
                      <TwistPack />
                    </>
                  }
                />
                <Route
                  path='/diwalipacks/lightuppack'
                  exact
                  element={
                    <>
                      <Navbar />
                      <LightupPack />
                    </>
                  }
                />

                <Route
                  path='/blogs'
                  exact
                  element={
                    <>
                      <Navbar />
                      <Blogs />
                      <Footer />
                    </>
                  }
                />
                <Route
                  path='/blogs/:id'
                  exact
                  element={
                    <>
                      <Navbar />
                      <BlogDetails />
                      <Footer />
                    </>
                  }
                />
                <Route
                  path='/privacy-policy'
                  exact
                  element={
                    <>
                      <Navbar />
                      <PrivacyPolicy />
                      <Footer />
                    </>
                  }
                />
                <Route
                  path='/terms-of-service'
                  exact
                  element={
                    <>
                      <Navbar />
                      <TermsOfService />
                      <Footer />
                    </>
                  }
                />
              </Routes>
            </ScrollToTop>
          </Router>
        </AuthProvider>
        <ToastContainer
          position='top-right'
          autoClose={2000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover={false}
          limit={1}
          className='custom-toast-container'
        />
      </div>
    </>
  )
}

export default App
